module.exports = __webpack_public_path__ + "static/media/avatar.c165e913.jpg";